import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, MailIcon, MapPinIcon, MessageCircleIcon, PhoneIcon } from 'lucide-react';
import { Reveal } from '../components/Reveal';
import { site } from '../data/site';
export function Contact() {
  const rows = [{
    icon: PhoneIcon,
    label: 'Bel ons',
    value: site.phone,
    href: site.phoneHref,
    external: false
  }, {
    icon: MessageCircleIcon,
    label: 'WhatsApp',
    value: 'Stuur ons een bericht',
    href: site.whatsapp,
    external: true
  }, {
    icon: MailIcon,
    label: 'E-mail',
    value: site.email,
    href: `mailto:${site.email}`,
    external: false
  }];
  return <section className="mx-auto max-w-shell px-5 pb-20 pt-24 sm:px-6 sm:pt-32 lg:px-10 lg:pb-28 lg:pt-44" data-id="element-1048" data-mp="17rk443nxe4be">
      <Reveal className="max-w-3xl" data-id="element-1049" data-mp="12z0eu9fvlkqr">
        <span className="flex items-center gap-3" data-id="element-1050" data-mp="12xpeykpjwx4x">
          <span className="hairline h-px w-10" aria-hidden="true" data-id="element-1051" data-mp="f963xxf4a695" />
          <span className="text-[11px] uppercase tracking-[0.28em] text-ember" data-id="element-1052" data-mp="abcy55hq7e9e">Contact</span>
        </span>
        <h1 className="mt-6 font-display text-4xl font-extrabold leading-[1.03] tracking-tightest text-chalk sm:text-5xl" data-id="element-1053" data-mp="15foxvvapp0hm">
          Kom langs. Uitsluitend op afspraak.
        </h1>
        <p className="mt-7 max-w-xl text-base leading-relaxed text-dim" data-id="element-1054" data-mp="1e7qs3bu6tkjg">
          Om alle aandacht op uw voertuig te richten werken wij enkel op afspraak. U kunt ons altijd bereiken via
          WhatsApp, telefoon of e-mail.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16" data-id="element-1055" data-mp="mhw17aqolmso">
        <Reveal data-id="element-1056" data-mp="qhef3mk34xm0">
          <ul className="divide-y divide-edge overflow-hidden rounded-2xl border border-edge bg-carbon" data-id="element-1057" data-mp="qixu79u092m7">
            {rows.map(row => {
            const Icon = row.icon;
            return <li key={row.label} data-id="element-1058" data-mp="10hx4ewuf56bb">
                  <a href={row.href} target={row.external ? '_blank' : undefined} rel={row.external ? 'noreferrer' : undefined} className="group flex items-center gap-4 px-6 py-5 transition-colors duration-200 ease-smooth hover:bg-panel" data-id="element-1059" data-mp="10dzlab7ucerf">
                    <Icon className="h-5 w-5 text-ember" aria-hidden="true" data-id="element-1060" data-mp="1h924zbzo5l1w" />
                    <span className="flex-1" data-id="element-1061" data-mp="1w59oea396ig4">
                      <span className="block text-xs uppercase tracking-[0.16em] text-dim" data-id="element-1062" data-mp="1w519ydrhf52t">{row.label}</span>
                      <span className="mt-1 block font-medium text-chalk" data-id="element-1063" data-mp="1r780nbuvtuyb">{row.value}</span>
                    </span>
                    <ArrowRightIcon className="h-4 w-4 text-dim transition-transform duration-200 ease-smooth group-hover:translate-x-0.5 group-hover:text-ember" aria-hidden="true" data-id="element-1064" data-mp="13ej5p9f0uxnt" />
                  </a>
                </li>;
          })}
            <li className="flex items-center gap-4 px-6 py-5" data-id="element-1065" data-mp="kq4g8qkcrrp4">
              <MapPinIcon className="h-5 w-5 text-ember" aria-hidden="true" data-id="element-1066" data-mp="kojot9tc4ovh" />
              <span data-id="element-1067" data-mp="fqi4klk6ajif">
                <span className="block text-xs uppercase tracking-[0.16em] text-dim" data-id="element-1068" data-mp="fr1d5bnxnvjs">Werkplaats</span>
                <span className="mt-1 block font-medium text-chalk" data-id="element-1069" data-mp="2rcjxcmqymn8g">{site.address}</span>
              </span>
            </li>
          </ul>

          <div className="mt-6 rounded-2xl border border-edge bg-carbon px-6 py-5" data-id="element-1070" data-mp="2hgz2d8kb6n87">
            <h2 className="text-xs uppercase tracking-[0.2em] text-dim" data-id="element-1071" data-mp="2mfjuekpeq0lk">Openingstijden</h2>
            <ul className="mt-4 space-y-3 text-sm" data-id="element-1072" data-mp="3a54onzr0gka5">
              {site.hours.map(h => <li key={h.day} className="flex justify-between gap-4" data-id="element-1073" data-mp="3a3bi0kgee025">
                  <span className="text-dim" data-id="element-1074" data-mp="3f3fy49de8sru">{h.day}</span>
                  <span className="text-chalk" data-id="element-1075" data-mp="3157trge12p6n">{h.time}</span>
                </li>)}
            </ul>
          </div>

          <Link to="/book" className="group mt-6 inline-flex items-center gap-2 rounded-full bg-ember px-6 py-3.5 text-sm font-semibold text-void transition-[background-color,box-shadow] duration-200 ease-smooth hover:bg-white hover:glow" data-id="element-1076" data-mp="354gmchxc0h0m">
            Afspraak maken
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-smooth group-hover:translate-x-0.5" aria-hidden="true" data-id="element-1077" data-mp="29zlolql8mmkw" />
          </Link>
        </Reveal>

        <Reveal delay={0.06} className="overflow-hidden rounded-2xl border border-edge" data-id="element-1078" data-mp="2064xiuchjlkx">
          <iframe title="Locatie van Daily Car Care op de kaart" src="https://www.openstreetmap.org/export/embed.html?bbox=4.3095%2C51.8395%2C4.3455%2C51.8595&layer=mapnik&marker=51.8495%2C4.3275" className="h-[520px] w-full opacity-80 grayscale" loading="lazy" data-id="element-1079" data-mp="1vaxza21zj93e" />
        </Reveal>
      </div>
    </section>;
}